import { type Dispatch, type SetStateAction, useState } from 'react'
import { useDidChange } from '#src/hooks/useDidChange.ts'

export function useSyncedState<S>(value: S): [S, Dispatch<SetStateAction<S>>] {
  const [state, setState] = useState(value)
  const didChange = useDidChange(value)
  if (didChange) {
    setState(value)
  }
  return [state, setState]
}
